import { Injectable } from '@angular/core';
import { ExceptionCategory } from '../enums/exception-category';
import { ExceptionSeverity } from '../enums/exception-severity';
import { ExceptionType } from '../enums/exception-type';

@Injectable({ providedIn: 'root' })
export class ExceptionEvent {
  type?: ExceptionType;
  category?: ExceptionCategory;
  severity?: ExceptionSeverity;
  status: string = 'OPEN';
  module: string = 'walletron-pages-ui';
  brandCode?: string;
  source?: string;
  exceptionCode?: string;
  exceptionMessage?: string;

  constructor() {
  }

  initialize(
      source: string, 
      exceptionCode: string, 
      exceptionMessage: string,
      type: string = 'OTHER', 
      category: string = 'CUSTOMER_ACCOUNT_FAILURE', 
      severity: string = 'LOW',
      brandCode: string
    ): void {
    this.source = source;
    this.exceptionCode = exceptionCode;
    this.exceptionMessage = exceptionMessage;
    this.type = ExceptionType[type as keyof typeof ExceptionType];
    this.category = ExceptionCategory[category as keyof typeof ExceptionCategory];
    this.severity = ExceptionSeverity[severity as keyof typeof ExceptionSeverity];
    this.brandCode = brandCode;
  }

  // setType(type: ExceptionType): void {
  //   this.type = type;
  // }

  // setCategory(category: ExceptionCategory): void {
  //   this.category = category;
  // }

  // setSeverity(severity: ExceptionSeverity): void {
  //   this.severity = severity;
  // }

  toJson(): string {
    return JSON.stringify({
      type: this.type,
      category: this.category,
      severity: this.severity,
      status: this.status,
      brandCode: this.brandCode,
      module: this.module,
      source: this.source,
      exceptionCode: this.exceptionCode,
      exceptionMessage: this.exceptionMessage,
    });
  }
}

